// Sub‑reducer for the `patientDischargeStep` slice.
// Holds discharge related information with status/error metadata.
import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../../constants/status.constant';

const initialState = () => ({
  releaseDate: null,
  releaseReasonDescription: null,
  deathReleaseSignal: null,
  status: STATUS.IDLE,
  error: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case types.ACTION_TYPES.DISCHARGE_PATIENT:
      return {
        ...state,
        ...action.payload,
        status: STATUS.IDLE,
        error: null
      };
    case types.ACTION_TYPES.RESET:
      return initialState();
    default:
      return state;
  }
};

export default reducer;
